import "../../styles/Cards.css";
import CardList from "../../components/CardList";
import Navbar from "../../components/Navbar";
import TopNavbar2side from "../../components/TopNavbar2side";
import "../../styles/Buttons.css";
import "../../styles/Containers.css";
import "../../styles/Colors.css";
import { Link, useNavigate } from "react-router-dom";
import GoToTop from "../../components/GoToTop";
import { useEffect, useState, useFetch } from "react";
import NinjaModal from "../ninja/components/NinjaModal";

const Cards = () => {
  const nav = useNavigate();
  // const { myFetch } = useFetch();
  const [searchInput, setSearchInput] = useState("");
  const [isValid, setIsValid] = useState(false);
  const [error, setError] = useState("");
  const [showNinja, setShowNinja] = useState(false);

  useEffect(() => {
    if (searchInput.length > 2) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  }, [searchInput]);

  const handleKeyDown = (event) => {
    setSearchInput(event.target.value);
  };

  const handlePressSearch = (event) => {
    if (isValid) {
      nav(`/Search?q=${searchInput}`);
    }
    // handle less than 3 digit word
    setSearchInput(event.target.value);
    setError(
      event.target.value.length < 2 ? "کلمات 3 حرفی به بالا رو سرچ کن" : ""
    );
  };

  const handleOpenNinja = () => {
    setShowNinja(true);
  };

  const handleCloseNinja = () => {
    setShowNinja(false);
  };

  return (
    <>
      <TopNavbar2side
        title="همه غذاها"
        sideTitle="علاقه‌مندی ها"
        buttonHref={["/favorites"]}
        buttonIcon={["icon-iconsave"]}
        classN={["rectangleSmall b-grey-5"]}
      />

      <div>
        <div className="search">
          <input onChange={handleKeyDown} className="searchTerm yekan" placeholder="غذا، میانوعده، مواد اولیه "></input>
          <button
            onClick={handlePressSearch}
            className="icon-iconsearch searchButton b-grey-5 purple-1"
          ></button>
          <button
            onClick={handleOpenNinja}
            className="icon-iconfilter filterButton b-grey-5 purple-1"
          ></button>
        </div>
        <div className="rightAlign">
          {error && <p className="error">{error}</p>}
        </div>

        <CardList />
        {/* <Link to="/addCard" className="float white b-purple-1">
          <span className="icon-iconplus"></span>
        </Link> */}
      </div>

      <Navbar />

      <GoToTop />

      <NinjaModal
        showNinja={showNinja}
        handleOpenNinja={handleOpenNinja}
        handleCloseNinja={handleCloseNinja}
      ></NinjaModal>
    </>
  );
};

export default Cards;
